/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { STATUS } from 'sarsaparilla';

import {
    SET_FETCH_TOUR_RATINGS_STATUS,
    FETCH_TOUR_RATINGS_SUCCESS,
    FETCH_TOUR_RATINGS_ERROR,
} from '../actions/tourRatingsActions';

export const initialState = {
    loadingStatus: STATUS.IDLE,
    isLoading: true,
    error: null,
};

export const tourRatingsReducers = (state = initialState, action) => {
    switch (action.type) {
        case SET_FETCH_TOUR_RATINGS_STATUS:
            return {
                ...state,
                loadingStatus: action.payload,
            };
        case FETCH_TOUR_RATINGS_SUCCESS: {
            return {
                ...state,
                data: action.payload,
                isLoading: false,
                loadingStatus: STATUS.SUCCESS,
                error: null,
            };
        }
        case FETCH_TOUR_RATINGS_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading: false,
                loadingStatus: STATUS.ERROR,
            };
        default:
            return state;
    }
};
